<template>
  <v-card>
    <div class="pa-4">
      <div class="d-flex align-center">
        <h4>Streaming Links</h4>
        <v-dialog v-model="dialog" width="500">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              small
              v-if="allowAdd != false"
              rounded
              class="ml-auto"
              color="primary"
              v-bind="attrs"
              v-on="on"
              @click="newURL"
              ><i class="fa fa-plus"></i
            ></v-btn>
          </template>
          <v-card>
            <v-card-title class="text-h6 grey lighten-2">
              Add Streaming Links
            </v-card-title>
            <v-form ref="ref_add_music" @submit="lc_add_music">
              <div class="pa-4">
                <v-autocomplete
                  v-model="data.type"
                  :items="getItems()"
                  outlined
                  dense
                  label="Provider Type"
                  :rules="[myrules.required]"
                ></v-autocomplete>
                <v-text-field
                  outlined
                  v-model="data.url"
                  label="Your Profile URL"
                  dense
                  :rules="[myrules.required]"
                ></v-text-field>
              </div>

              <v-divider></v-divider>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" text type="submit"> Save </v-btn>
                <v-btn color="primary" text @click="dialog = false">
                  Cancel
                </v-btn>
              </v-card-actions>
            </v-form>
          </v-card>
        </v-dialog>
      </div>
    </div>
    <v-divider></v-divider>
    <div class="pa-4">
      <div
        v-if="musicReferenceLoading"
        class="d-flex align-items-center justify-center"
      >
        <v-progress-circular indeterminate />
      </div>
      <div v-else class="d-flex align-center social-icons">
        <a
          :href="
            musicReference.url.includes('https://') ||
            musicReference.url.includes('https://')
              ? musicReference.url
              : 'https://' + musicReference.url
          "
          v-for="(musicReference, k) of references"
          :key="k"
          class="mr-3"
          target="_blank"
          style="position: relative"
        >
          <v-avatar size="48" :class="musicReference.type.toLowerCase()"
            ><i :class="['fa', 'fa-' + musicReference.type.toLowerCase()]"></i
          ></v-avatar>
          <v-dialog v-model="dialog1" width="500">
            <template v-slot:activator="{ on, attrs }">
              <v-avatar
                size="18"
                class="edit-icon"
                style="position: absolute; bottom: 0; left: 0"
                v-bind="attrs"
                v-if="allowAdd != false"
                v-on="on"
                @click="
                  (e) => {
                    edit(e);
                    data = { ...musicReference, idx: k };
                  }
                "
                ><i class="fa fa-pencil"></i
              ></v-avatar>
            </template>
            <v-card>
              <v-card-title class="text-h6 grey lighten-2">
                Edit Streaming Links
              </v-card-title>
              <v-form ref="ref_edit_music" @submit="lc_edit_music">
                <div class="pa-4">
                  <v-text-field
                    outlined
                    label="Your Profile URL"
                    dense
                    v-model="data.url"
                    :rules="[myrules.required]"
                  ></v-text-field>
                </div>

                <v-divider></v-divider>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" text type="submit"> Save </v-btn>
                  <v-btn color="primary" text @click="dialog1 = false">
                    Cancel
                  </v-btn>
                </v-card-actions>
              </v-form>
            </v-card>
          </v-dialog>
          <v-avatar
            size="18"
            class="delete-icon"
            style="position: absolute; bottom: 0; right: 0"
            v-if="allowAdd != false"
            @click="
              (e) => {
                e.preventDefault();
                deleteMusicReference({ id: authUser.id, idx: k });
              }
            "
            ><i class="fa fa-trash"></i
          ></v-avatar>
        </a>
        <div v-if="references.length == 0">
          <p class="ma-0">No Music References Yet</p>
        </div>
      </div>
      <!-- <div class="music">
        <h4 class="mb-2">Music Title</h4>
        <div class="audio-wrapper">
          <audio controls style="width: 100%"></audio>
        </div>
      </div>
      <div class="music mt-5">
        <h4 class="mb-2">Music Title</h4>
        <div class="audio-wrapper">
          <audio controls style="width: 100%"></audio>
        </div>
      </div>
      <div class="music mt-5">
        <h4 class="mb-2">Music Title</h4>
        <div class="audio-wrapper">
          <audio controls style="width: 100%"></audio>
        </div>
      </div> -->
    </div>
  </v-card>
</template>

<script>
export default {
  name: "Streaming Links",
  props: ["references", "allowAdd"],
  mounted() {
    let id = this.authUser.id;
    this.getMusicReferences(id);
  },
  data() {
    return {
      dialog: false,
      dialog1: false,
      items: ["Spotify", "Apple", "SoundCloud"],
      data: {
        type: "",
        url: "",
      },
    };
  },
  methods: {
    edit(e) {
      e.preventDefault();
      // this.dialog1 = !this.dialog1;
    },
    async lc_edit_music(e) {
      e.preventDefault();
      let validate = true;
      if (validate) {
        let id = this.authUser.id;
        await this.editMusicReference({ id, ...this.data });
        this.dialog1 = !this.dialog1;
      }
    },
    async lc_add_music(e) {
      e.preventDefault();
      let validate = this.$refs.ref_add_music.validate();
      if (validate) {
        let id = this.authUser.id;
        await this.addMusicReference({ id, ...this.data });
        this.dialog = !this.dialog;
        this.$refs.ref_add_music.reset();
      }
    },
    getItems() {
      let items = ["Spotify", "Apple", "SoundCloud"];
      let newItems = [];
      items.forEach((item) => {
        let obj = this.references.find(
          (musicReference) => musicReference.type == item
        );
        if (!obj) {
          newItems.push(item);
        }
      });
      return newItems;
    },
    newURL() {
      this.$refs.ref_add_music.reset();
    },
  },
};
</script>

<style scoped>
.audio-wrapper {
  background-color: rgba(200, 200, 200, 1) !important;
  display: flex;
  align-items: center;
  justify-content: center;
}
.audio-wrapper audio::-webkit-media-controls-panel {
  background-color: rgba(200, 200, 200, 1);
}
</style>